import React from "react"
import { Snackbar, Typography } from "@mui/material"
import { VARIANT_CONFIG_SNACKBAR } from "./constants"
import * as Styled from "./SnackBar.styled"
import PropTypes from "prop-types"
import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"
import { ReactComponent as CloseIcon } from "src/v2/assets/icons/close-icon.svg"
import theme from "../../theme/theme"

function CustomSnackbar({ open, onClose, message, variant, ...props }) {
  const config =
    VARIANT_CONFIG_SNACKBAR[variant] || VARIANT_CONFIG_SNACKBAR.success

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={5000}
      {...props}
    >
      <Styled.SnackbarContainer bgColor={config.bgColor}>
        <Styled.IconWrapper>
          {config.icon || <CheckIcon sx={{ color: "white" }} />}
          <Typography variant="body1">
            {message}
          </Typography>
        </Styled.IconWrapper>
        <Styled.Divider />
        <Styled.CloseButton onClick={onClose}>
          <CloseIcon style={{ color: theme.palette.icon.main }} />
        </Styled.CloseButton>
      </Styled.SnackbarContainer>
    </Snackbar>
  )
}

CustomSnackbar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(Object.keys(VARIANT_CONFIG_SNACKBAR)).isRequired,
}

export default CustomSnackbar
